import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderRequisitionsService } from '../services/order-requisitions.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { DialogService } from 'ng2-bootstrap-modal';
import { ConfirmComponent } from '../../shared/confirm/confirm.component';


@Component({
    selector: 'app-order-requisitions',
    templateUrl: './order-requisitions.component.html',
    styleUrls: ['./order-requisitions.component.scss'],
    providers: [OrderRequisitionsService]
})
export class OrderRequisitionsComponent implements OnInit {

    titleCounter = [1, 2, 3, 4, 5, 6];

    private requisitionID;
    private userID;
    private requisitionDetails;
    private requisitionFlow;
    private comentario;

    constructor(private route: ActivatedRoute,
        private orderRequisitionsService: OrderRequisitionsService,
        private flashMessagesService: FlashMessagesService,
        private dialogService: DialogService,
        private router: Router) { }

    ngOnInit() {
        let routeSub = this.route.params.subscribe(params => {
            this.requisitionID = params['id'];
        });
        console.log("ah", this.requisitionID);
        if (this.requisitionID) {
            this.getRequisitionDetail();
            this.getRequisitionCommittee()
        }
        this.userID = localStorage.getItem('yara.userID');
    }

    getRequisitionDetail() {
        this.orderRequisitionsService.getRequisitionDetail(this.requisitionID).subscribe(result => {
            if (result.Success) {
                this.requisitionDetails = result.Result;
                console.log(this.requisitionDetails);
            } else {
                this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
            }
        }, error => {
            console.log(error);
        });
    }

    getRequisitionCommittee() {
        this.orderRequisitionsService.getRequisitionFlow(this.requisitionID).subscribe(result => {
            if (result.Success) {
                this.requisitionFlow = result.Result;
                console.log("oie", this.requisitionFlow);
            } else {
                this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
            }
        }, error => {
            console.log(error);
        });
    }

    onApproveOrders() {
        var message = 'Confirma a aprovação das ordens de venda?'
        let disposable = this.dialogService.addDialog(ConfirmComponent, {
            title: 'Confirmar Aprovação',
            message: message
        },
            { backdropColor: 'rgba(0, 0, 0, 0.5)' })
            .subscribe((isConfirmed) => {
                //We get dialog result
                if (isConfirmed) {
                    this.approveOrders();
                }
                else {
                    //Do nothing here
                }
            });
        //Close dialog calling disposable.unsubscribe();
        //If dialog was not closed manually close it by timeout
        setTimeout(() => {
            disposable.unsubscribe();
        }, 15000);
    }

    approveOrders() {

        this.orderRequisitionsService.approveOrders(this.requisitionID, this.comentario).subscribe(result => {
            if (result.Success) {
                this.flashMessagesService.show("Aprovação salva com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
                this.router.navigateByUrl('/cockpit');
            } else {
                this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
            }
        }, error => {
            console.log(error);
        });
    }

    onReproveOrders() {
        var message = 'Confirma a reprovação das ordens de venda?'
        let disposable = this.dialogService.addDialog(ConfirmComponent, {
            title: 'Confirmar Reprovação',
            message: message
        },
            { backdropColor: 'rgba(0, 0, 0, 0.5)' })
            .subscribe((isConfirmed) => {
                //We get dialog result
                if (isConfirmed) {
                    this.repproveOrders();
                }
                else {
                    //Do nothing here
                }
            });
        //Close dialog calling disposable.unsubscribe();
        //If dialog was not closed manually close it by timeout
        setTimeout(() => {
            disposable.unsubscribe();
        }, 15000);
    }

    repproveOrders() {
        this.orderRequisitionsService.reproveOrders(this.requisitionID, this.comentario).subscribe(result => {
            if (result.Success) {
                this.flashMessagesService.show("Reprovação salva com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
                this.router.navigateByUrl('/cockpit');
            } else {
                this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
            }
        }, error => {
            console.log(error);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/order-requisitions/order-requisitions/order-requisitions.component.ts